<div class="toast-container mt-2 px-2 fixed z-100 top-0 right-0" aria-live="polite" aria-atomic="true">
    @for (toast of toastService.toasts; track toast; let i = $index) {
    <ngb-toast [class]="toast.classname + ' rounded-lg shadow-md text-base min-w-52!'" [autohide]="true" #toastEl [delay]="toast.duration || 5000" (hidden)="toastService.remove(i)">

        <div class="flex flex-row justify-between gap-1">
            <span>{{toast.content}}</span>
            <button (click)="toastEl.hide(); toastService.remove(i)">
                @if(toast.buttontext){
                    {{toast.buttontext}}
                }@else {
                    <i class="bi bi-x-lg"></i>
                }
            </button>
        </div>
    </ngb-toast>
    }
</div>
